// hide Intercom Messenger before page unloads to prevent auto-reopens
window.addEventListener("beforeunload", () => {
  if (window.Intercom) {
    window.Intercom("hide")
  }
})
